import { render, staticRenderFns } from "./tldOrderConfirm.vue?vue&type=template&id=cd7b9164&scoped=true&"
import script from "./tldOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./tldOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./tldOrderConfirm.vue?vue&type=style&index=0&id=cd7b9164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b9164",
  null
  
)

export default component.exports